var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureIcon5(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_909_1718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.025 27.5272C37.9123 25.6216 41.0799 21.0312 41.0013 15.9678C41.0013 9.00856 34.7384 3.34692 27.0402 3.34692C19.342 3.34692 13.0791 9.00856 13.0791 15.9678C13.0005 21.0312 16.168 25.6216 21.0554 27.5272L21.1636 27.5835L21.9027 28.7477C20.5832 29.481 20.1327 31.1022 20.8964 32.3689C20.9968 32.5354 21.1158 32.691 21.2513 32.8329C20.2166 33.9218 20.2972 35.6098 21.4314 36.6033C21.9467 37.0545 22.6199 37.3033 23.3172 37.3004H30.7632C32.2986 37.3069 33.5487 36.1172 33.5554 34.6432C33.5584 33.9737 33.2992 33.3274 32.8292 32.8329C33.8599 31.7543 33.7845 30.0778 32.661 29.0885C32.5132 28.9584 32.3513 28.8441 32.1777 28.7477L32.9168 27.5835L33.025 27.5272ZM30.7631 35.5134H23.3171C22.8031 35.5134 22.3864 35.1133 22.3864 34.6199C22.3864 34.1264 22.8031 33.7264 23.3171 33.7264H30.7631C31.2771 33.7264 31.6938 34.1264 31.6938 34.6199C31.6938 35.1133 31.2771 35.5134 30.7631 35.5134ZM30.7631 31.9393H23.3171C22.8031 31.9393 22.3864 31.5393 22.3864 31.0458C22.3864 30.5524 22.8031 30.1523 23.3171 30.1523H30.7631C31.2771 30.1523 31.6938 30.5524 31.6938 31.0458C31.6938 31.5393 31.2771 31.9393 30.7631 31.9393ZM32.1801 25.9339L31.8079 26.128C31.6639 26.2034 31.543 26.3139 31.4575 26.4483L30.2404 28.3653H29.8323V21.5871L34.2133 17.3813L32.8972 16.1178L28.2435 20.5854C28.069 20.7529 27.9709 20.9801 27.9708 21.2171V28.3652H26.1093V21.2171C26.1092 20.9801 26.0112 20.7529 25.8366 20.5854L21.1829 16.1178L19.8669 17.3812L24.2479 21.587V28.3652H23.8397L22.6227 26.4481C22.5372 26.3138 22.4163 26.2033 22.2722 26.1279L21.9001 25.9338C21.8702 25.9185 21.8396 25.9047 21.8083 25.8924C17.6003 24.2672 14.8699 20.3216 14.9404 15.9678C14.9404 9.99421 20.3681 5.13395 27.0401 5.13395C33.7121 5.13395 39.1397 9.99421 39.1397 15.9678C39.2102 20.3216 36.4798 24.2672 32.2719 25.8924C32.2406 25.9048 32.2099 25.9186 32.1801 25.9339Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91058 3.4416L7.07812 5.03992L12.6622 7.72029L13.4947 6.12198L7.91058 3.4416Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2863 3.78475L40.3638 5.68115L40.9527 7.37633L46.8753 5.47992L46.2863 3.78475Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35594 14.9625H3.77148V16.7495H9.35594V14.9625Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3091 14.9625H44.7246V16.7495H50.3091V14.9625Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6622 25.7781L7.07812 28.4585L7.91058 30.0568L13.4947 27.3764L12.6622 25.7781Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4174 25.7813L40.585 27.3796L46.1691 30.06L47.0015 28.4617L41.4174 25.7813Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9709 -2.90771H26.1094V1.55985H27.9709V-2.90771Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0314 39.0874V37.3004C41.8886 37.3004 28.985 40.1183 28.9018 45.342H25.1779C25.0947 40.1183 12.1912 37.3004 0.0483398 37.3004V39.0874C13.6836 39.0874 23.2049 42.3727 23.3119 45.342H0.0483398V47.1291H54.0314V45.342H30.7678C30.8749 42.3727 40.3961 39.0874 54.0314 39.0874Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0974258 41.7702L-0.000488281 43.5547L17.6867 44.4491L17.7847 42.6645L0.0974258 41.7702Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9836 41.7686L36.2964 42.6647L36.3945 44.4492L54.0817 43.5531L53.9836 41.7686Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_909_1718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 48,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon5);
export default __webpack_public_path__ + "static/media/feature-icon-5.af638a2cb4fc81988fc1d3e3030fabd3.svg";
export { ForwardRef as ReactComponent };